import { connect } from 'react-redux'

import { setDamage } from './actions'

import AddDamage from './AddDamage'

const mapDispatchToProps = {
  setDamage,
}

const mapStateToProps = state => {
  return {
    damage: state.whatHappened.damage,
    type: state.whatHappened.type,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddDamage)
